import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Footer } from './Footer';
import { Header } from './Header';

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const hideLayoutFor = ['/', '/employer', '/workforce', '/healthcare', '/retail', '/education'];
  const shouldHideLayout = hideLayoutFor.some((path) => pathname === path);

  return (
    <>
      <div className="min-h-screen">
        <ToastContainer theme="colored" limit={1} autoClose={2000} position="top-center" />
        <div className="w-full block">
          {!shouldHideLayout && <Header />}
          <main>
            <Outlet />
          </main>
          {!shouldHideLayout && <Footer />}
        </div>
      </div>
    </>
  );
};

export default Layout;
